import React from 'react';
import { getAuthErrorMessage } from '../authErrorStore';

interface AuthErrorProps {
  error?: unknown;
  onRetry?: () => void;
}

// Rendered when authentication fails fatally. Shows the underlying message
// (e.g. AADSTS65005) and a manual Retry button instead of auto re-triggering
// the login redirect, which would loop indefinitely.
export function AuthError({ error, onRetry }: AuthErrorProps) {
  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: '16px',
        padding: '24px',
        textAlign: 'center',
      }}
    >
      <h1 style={{ margin: 0, fontSize: '20px' }}>No se pudo iniciar sesión</h1>
      <p style={{ margin: 0, maxWidth: '640px', color: '#555', wordBreak: 'break-word' }}>
        {getAuthErrorMessage(error)}
      </p>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          style={{
            padding: '8px 20px',
            border: 'none',
            borderRadius: '4px',
            backgroundColor: '#e6375a',
            color: '#fff',
            cursor: 'pointer',
            fontSize: '14px',
          }}
        >
          Reintentar
        </button>
      )}
    </div>
  );
}

export default AuthError;
